import { render, staticRenderFns } from "./AdminClientsHeader.module.vue?vue&type=template&id=caa1b9aa&scoped=true&"
import script from "./AdminClientsHeader.module.vue?vue&type=script&lang=js&"
export * from "./AdminClientsHeader.module.vue?vue&type=script&lang=js&"
import style0 from "./AdminClientsHeader.module.vue?vue&type=style&index=0&id=caa1b9aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa1b9aa",
  null
  
)

export default component.exports